// extracted by mini-css-extract-plugin
module.exports = {"button":"CallButton_button__34oZu","text":"CallButton_text__2Sf0p"};